import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { ArgyleIncomeStream, AdditionalIncomeSource, IncomeStreamType, AdditionalIncomeSourceType, IncomeSourceSubType } from 'src/app/models/Argyle';
import { IncomeSourceModalComponent } from '../income-source-modal/income-source-modal.component';

@Component({
  selector: 'app-argyle-payroll-sync-modal',
  templateUrl: './argyle-payroll-sync-modal.component.html',
  styleUrls: ['./argyle-payroll-sync-modal.component.less']
})
export class ArgylePayrollSyncModalComponent  implements OnInit, OnDestroy {
  @Input() stream :ArgyleIncomeStream;
  @Output() public saved : EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public modalService: NgbModal, private toast: ToastrService, public auth: AuthService, public appData: ApplicantDataService,public groups: GroupApplicantsService) { }
  ngOnDestroy(): void {
    // throw new Error("Method not implemented.");
  }
  ngOnInit(): void {
    // throw new Error("Method not implemented.");
    console.log(this.stream);
  }
  cancel(){ this.modalService.dismissAll();}


  mapToSource(i : ArgyleIncomeStream){
    console.log('adding new income source', i);
    let src = new AdditionalIncomeSource();
    src.maappedFromIncomeVer = true;
    src.amount = i.summary.monthlyGrossAverage;
    // TODO: come back and wrap this up in a lil mapping object for all the income streams so the logic to get an income source mapping is kept in one place within the income stream builders.
    if(this.stream.streamType == IncomeStreamType.PayrollSync || this.stream.streamType == IncomeStreamType.WorkNumber)
    {
      src.incomeType = AdditionalIncomeSourceType.currentEmployment;
      if(this.stream.streamType == IncomeStreamType.PayrollSync)
      {
        src.incomeSourceDescription = `${this.stream.historicalData[0].identityData.employer}(${this.stream.historicalData[0].identityData.employment_status} employment) verified via payroll sync`;
        src.incomeVerified = this.stream.historicalData[0].identityData.employment_status == 'active';
      }else{
        src.incomeSourceDescription = `${i.historicalData[0].tsvemployerV100.namE1}(${i.historicalData[0].tsvemployeeV100.employeestatus.message} employment) verified via work number`
        src.incomeVerified = i.historicalData[0].tsvemployeeV100.employeestatus.message.toLowerCase() == 'active';
      }
    }

    if(this.stream.streamType == IncomeStreamType.BankSync)
    {
      src.incomeType = AdditionalIncomeSourceType.bankStatements;
      src.incomeSourceDescription = `${this.stream.firstName} ${this.stream.lastName}(${this.stream.historicalData[0].asset.type} account) verified via bank sync`;
      src.incomeVerified = true;
    }

    if(this.stream.streamType == IncomeStreamType.DocUpload)
    {
      if(this.stream.subType == IncomeSourceSubType.Paystubs){
        src.incomeType = AdditionalIncomeSourceType.PayStubs;
        src.incomeSourceDescription = `${this.stream.firstName} ${this.stream.lastName}(Pay Stubs) sent via document upload`;
        // src.incomeVerified = true;
      }
      if(this.stream.subType == IncomeSourceSubType.W2){
        src.incomeType = AdditionalIncomeSourceType.W2;
        src.incomeSourceDescription = `${this.stream.firstName} ${this.stream.lastName}(W-2) sent via document upload`;
        src.incomeVerified = this.stream.historicalData[0].metadata.ocr_authenticity_score >= 80;
      }
    }

    const modalRef1 = this.modalService.open(IncomeSourceModalComponent, { centered: true, size: 'lg' })
    modalRef1.componentInstance.name = 'IncomeSourceModalComponent';
    modalRef1.componentInstance.screeningId = this.stream.screeningId;
    modalRef1.componentInstance.applicantName = `- ${this.stream.firstName} ${this.stream.lastName}`;
    // modalRef1.componentInstance.showSnapptToggle = this.screening.billingRule;
    modalRef1.componentInstance.sourceTypes = this.appData.incomeSourceTypes;
    modalRef1.componentInstance.newSource = src;
    modalRef1.componentInstance.addingFromVerified = true;
    // // if(src != null)this.modalRef1.componentInstance.newSource = src;
    modalRef1.componentInstance.saved.subscribe((dta: boolean) => {
      this.saved.emit();
      modalRef1.dismiss();
    });
    modalRef1.componentInstance.closed.subscribe((dta: boolean) => {
      modalRef1.dismiss();
    });
    
  }

}
